<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header pt-4">
      <!-- Page Title -->
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ getCurrentCampaign.name }}</span>
        <h3 class="page-title">{{ $t("campaigns.prospects") }}</h3>
      </d-col>

      <!-- Employee / Company Table View Switcher -->
      <!-- <d-col class="d-flex">
        <d-button-group size="small" class="d-inline-flex ml-auto my-auto">
          <d-link tag="button" class="btn btn-white" :to="{ title: 'file-manager-list' }">
            <i class="material-icons">&#xE8EF;</i>
          </d-link>
          <d-link tag="button" class="btn btn-white" :to="{ title: 'file-manager-cards' }">
            <i class="material-icons">&#xE8F0;</i>
          </d-link>
        </d-button-group>
      </d-col>-->
    </d-row>
    <!-- Next Step -->

    <!-- Table Selectors -->
    <hr class="mb-0" />
    <d-nav class="mb-2 border-box nav-box">
      <d-nav-item class="tab-nav" :active="tabSelected === 'New'">
        <div @click="selectTab('New')">
          {{ $t('campaigns.sortnew') }}
          <span>({{ newAmount }})</span>
        </div>
      </d-nav-item>

      <d-nav-item class="tab-nav" :active="tabSelected === 'Sent'">
        <div @click="selectTab('Sent')">
          {{ $t('campaigns.sortsent') }}
          <span>({{ sentAmount }})</span>
        </div>
      </d-nav-item>
    </d-nav>

    <!-- Table -->
    <d-card>
      <d-card-body>
        <d-row class="py-2">
          <!-- Showing Percentage Progress -->
          <span class="w-100 pl-3">
            <!-- Create Message Button -->
            <d-link
              v-if="tabSelected === 'New'"
              :to="{ name: 'template-editor', params: { id: getCurrentCampaign._id } }"
            >
              <d-button
                size="sm"
                class="btn-accent btn-form-end ml-auto d-table mr-3"
                :disabled="isCampaignLoading || getCurrentCampaign.emailSent || !getCurrentCampaign.contacts.length"
              >
                <i class="material-icons"></i>
                {{ isCampaignLoading ? "Loading..." : (getCurrentCampaign.emailSent ? "Message Sent" : "Create Message") }}
              </d-button>

              <!-- Add Prospects Button -->
            </d-link>

            <d-button
              size="sm"
              class="btn-success btn-form-end ml-auto d-table mr-3"
              :disabled="isNewCampaign || isCampaignLoading || (!getCurrentUser.premium && contacts.length >= 5)"
              @click="addMoreProspects()"
            >
              <i class="material-icons large-icon">add</i>
              {{ isCampaignLoading ? 'Loading...' : 'Add More Prospects' }}
            </d-button>
          </span>
        </d-row>

        <div class="float-right">
          <span class="font-weight-bold">{{ totalAmount }}</span>
          {{ $t('campaigns.prospectsselected') }}
        </div>

        <div class="mb-4" />
        <!-- <hr class="mb-0" /> -->
        <!-- Table Tabs -->
        <!--
        <d-nav class="mb-2 border-box nav-box">
          <d-nav-item
            v-for="tabName in tableTabs"
            :key="tabName.tabName"
            class="tab-nav"
            @click="tabselected = tabName.id"
          >
            {{ tabName.tabName }}
            <span>({{ tabName.amount }})</span>
          </d-nav-item>
        </d-nav>
        -->

        <!-- /Table Tabs -->
        <v-client-table
          :data="contacts"
          :columns="columns"
          :options="clientTableOptions"
          class="dataTables_wrapper file-manager file-manager-list"
        >
          <!-- Item Icon Slot -->
          <div slot="icon" slot-scope="props" class="file-manager__item-icon">
            <div>
              <img
                v-if="props.row.profilePic"
                class="company-avatar rounded-circle mr-2"
                :src="props.row.profilePic"
                alt
              />
              <img v-else class="company-avatar rounded-circle mr-2" alt />
            </div>
          </div>

          <!-- Item Name Slot -->
          <div slot="name" slot-scope="props" class="text-left">
            <div class="prospects-role">{{ props.row.currentTitle}}</div>
            <div class="prospects-company">{{ props.row.company ? props.row.company.name : "" }}</div>
            <div class="prospects-name">{{ `${props.row.firstName} ${props.row.lastName}` }}</div>
          </div>

          <div slot="location" slot-scope="props">{{ props.row.location || 'N/A'}}</div>
          <div
            slot="industry"
            slot-scope="props"
          >{{ props.row.company ? props.row.company.category.industry || 'N/A' : ""}}</div>

          <div slot="social" slot-scope="props">
            <a v-if="props.row.linkedInUrl" :href="props.row.linkedInUrl" target="_blank">
              <img src="@/assets/images/linkedin_small_icon.png" alt="linkedin icon" width="40" />
            </a>
          </div>

          <!-- Actions Column Slot -->
          <!-- <d-button-group
            slot="actions"
            slot-scope="props"
            size="small"
            class="d-flex justify-content-center"
          >
            
            <d-button
              class="icon-green btn-white unfilled"
              @click="handleActionClick('accept', props.row.id)"
              v-d-tooltip.hover="'Accept'"
            >
              <i class="icon-green material-icons unfilled">&#xe8dc;</i>
            </d-button>

            <d-button
              class="icon-red btn-white unfilled"
              @click="handleActionClick('reject', props.row.id)"
              v-d-tooltip.hover="'Reject'"
            >
              <i class="icon-red material-icons unfilled">&#xe15c;</i>
            </d-button>
           

            <d-button
              class="icon-black btn-white font-weight-bolder unfilled"
              @click="handleActionClick('blacklist', props.row.id)"
              v-d-tooltip.hover="'Blacklist'"
            >
              <i class="icon-black material-icons unfilled">&#xe14b;</i>
            </d-button>

            <d-button
              target="_blank"
              class="icon-yellow btn-white"
              @click="openCompanyUrl(props.row.company_domain)"
              :disabled="!props.row.company_domain"
              v-d-tooltip.hover="'Company Website'"
            >
              <i class="icon-yellow material-icons">link</i>
            </d-button>
          </d-button-group>-->
        </v-client-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import Vue from "vue";
import { ClientTable } from "vue-tables-2";

import "@/assets/scss/vue-tables.scss";
import "@/assets/scss/file-manager-list.scss";

const ListCount = "12";

Vue.use(ClientTable);

import _ from "lodash";
import { mapGetters } from "vuex";
import { CAMPAIGN_GET, CAMPAIGN_ADD_PROSPECTS } from "@/store/types";

export default {
  components: {
    ClientTable
  },
  computed: {
    ...mapGetters([
      "getCurrentCampaign",
      "isCampaignLoading",
      "getCurrentUser"
    ]),
    contacts() {
      if (this.getCurrentCampaign && this.getCurrentCampaign.contacts) {
        if (this.tabSelected === "New") {
          return this.getCurrentCampaign.newContacts;
        } else {
          return this.getCurrentCampaign.sentContacts;
        }
      } else {
        return [];
      }
    },
    totalAmount() {
      if (this.getCurrentCampaign && this.getCurrentCampaign.contacts) {
        return this.getCurrentCampaign.contacts.length;
      }
      return 0;
    },
    newAmount() {
      if (this.getCurrentCampaign && this.getCurrentCampaign.newContacts) {
        return this.getCurrentCampaign.newContacts.length;
      }
      return 0;
    },
    sentAmount() {
      if (this.getCurrentCampaign && this.getCurrentCampaign.sentContacts) {
        return this.getCurrentCampaign.sentContacts.length;
      }
      return 0;
    }
  },
  mounted() {
    if (!this.getCurrentCampaign) {
      // If reloading the page
      this.$store.dispatch(CAMPAIGN_GET, this.$route.params.id).then(resp => {
        this.tableTabs[0].amount = resp.data.newContacts.length;
        this.tableTabs[1].amount = this.getCurrentCampaign.sentContacts.length;
      });
    }
  },
  destroyed() {
    if (this.$route.name !== "template-editor") {
      this.$store.commit(CAMPAIGN_GET, null);
    }
  },
  data() {
    return {
      prospectCount: 45,
      isNewCampaign: false,
      tabSelected: "New",
      columns: ["icon", "name", "location", "social", "industry"],
      /**
       * Vue Tables Configuration Options
       * @see https://github.com/matfish2/vue-tables-2
       */
      clientTableOptions: {
        perPage: 10,
        recordsPerPage: [10, 25, 50, 100],
        skin: "file-manager file-manager-list table dataTable",
        sortIcon: {
          base: "fas float-right mt-1 text-muted",
          up: "fa-caret-up",
          down: "fa-caret-down"
        },
        texts: {
          filterPlaceholder: "",
          limit: "Show"
        },
        pagination: {
          edge: true,
          nav: "scroll"
        }
      }
    };
  },
  methods: {
    handleActionClick(action, id) {
      const message = action === "edit" ? "Editing" : "Deleting";
      alert(`${message} item ${id}`); // eslint-disable-line no-alert
    },
    openCompanyUrl(domain) {
      if (!domain) {
        return;
      }
      window.open(`https://${domain}`, "_blank");
    },
    selectTab(tab) {
      this.tabSelected = tab;
    },
    addMoreProspects() {
      this.$store.dispatch(CAMPAIGN_ADD_PROSPECTS).then(resp => {
        this.$router.push({
          name: "campaign-companies",
          params: { id: this.getCurrentCampaign._id }
        });
      });
    }
  }
};
</script>
